import { createUseStyles } from "react-jss";

interface Props {
  isFullscreen: any;
  bodyHeight: any;
};

const useStyles = createUseStyles((theme: any) => ({
  root: {
    borderRadius: "10px",
    backgroundColor: theme.colors.white,
    width: "800px",
    maxWidth: '90vw',
    overflow: "hidden",
    margin: "20px",
    height: '100%',
    maxHeight: 'calc(100vh - 40px)',
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 20px 10px 20px",
    maxWidth: 'calc(100% - 40px)',
  },
  headerInnerWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    '& p': {
      fontWeight: "bold",
      marginBottom: "0",
    },
  },
    tabs: {
    width: '100%',
    padding: '0',
  },
  buttons: {
    display: 'flex',
    gap: '10px',
    flex: '0 0 fit-content',
  },
  button: {
    padding: '10px',
    width: '40px',
    height: '40px',
    '& > svg': {
      color: theme.colors.primaryBlue[500],
      width: '16px',
      height: '16px',
    },
  },
  body: {
    display: 'flex',
    justifyContent: 'center',
    height: (props: Props) => {
      if(props.bodyHeight) return props.bodyHeight + 'px';
      else return '100%';
    },
    backgroundImage: theme.colors.gradient,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    overflow: 'auto',
    position: 'relative',
  },
  bodyWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: (props: Props) => {
      if(props.isFullscreen) return '80%';
      else return 'calc(100% - 40px)';
    },
    padding: (props: Props) => {
      if(props.isFullscreen) return '30px 0 30px 0';
      else return '30px 20px 30px 20px';
    },
    height: 'calc(100% - 60px)',
    '&::after': {
      content: `''`,
      display: 'flex',
      width: '100%',
      height: '10px',
      minHeight: '10px',
    },
  },
  item: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    gap: '8px',
  },
  title: {
    display: 'flex',
    alignItems: 'flex-start',
    fontSize: '14px',
    fontWeight: 'bold',
    color: theme.colors.black,
    flex: '0 0 140px',
    minHeight: '34px',
    marginTop: '8px',
    '& > svg': {
      width: '18.5px',
      height: '18.5px',
      marginRight: '8px',  
    }, 
  },
  items: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: 'fit-content',
    maxWidth: '100%',
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 20px",
    gap: '15px',
    width: 'calc(100% - 40px)',
  },
  select: {
    width: '100% !important',
    flex: 'unset !important',
  },
  autoSelect: {
    width: 'fit-content !important',
    minWidth: '200px',
    flex: 'unset !important',
  },
  datepickers: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    width: 'fit-content',
  },
  dateSettings: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '22px',
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
  },
  warning: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    color: theme.colors.grey[550],
    fontSize: "12px",
    marginTop: '4px',
    '& > p': {
      '& > span': {
        cursor: 'pointer',
        fontWeight: '700',
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
    '& > svg': {
      width: '15px',
      height: '15px',
      minWidth: '15px',
      minHeight: '15px',
      color: theme.colors.systemOrange[500],
    },
  },
  error: {
    color: theme.colors.systemRed[500],
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
    '& > svg': {
      color: 'inherit',
      width: '16px',
      height: '16px',
    },
  },
  checkbox: {
    '& > span': {
      marginLeft: '-16px',
    },
  },
  loadingWrapper: {
    position: "absolute",
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: theme.zIndex.calendarLoading,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: 'rgba(128,128,128,0.15)',
  },
  spinner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    '& > svg': {
      color: theme.colors.primaryBlue[500],
    },
  },
}));

export default useStyles;